import {useAppDispatch} from "../app/store/hooks";
import {IInitialImagePrompt, IOtherPrompts, setPromptById} from "../app/store/slices/generationSlice";
import {UploadPhotoWidget} from "../widgets/UploadPhotoWidget";
import {TextPromptWidget} from "../widgets/TextPromptWidget";
import {InputEnum} from "../shared/types/EffectType.ts";

interface InputFeatureProps {
    input: IInitialImagePrompt | IOtherPrompts | undefined;
    onFocus?: () => void
}

export const InputFeature = ({input, onFocus}: InputFeatureProps) => {
    const dispatch = useAppDispatch();


    if (!input) return null;

    const errorOnFocusBlur = () => console.error('onFocus or onBlur is not defined');

    const handleChange = (value: string) => {
        dispatch(setPromptById({id: input.id, value}));
    };

    switch (input.type) {
        case InputEnum.InitialImage:
            return (
                <UploadPhotoWidget onPhotoSelected={handleChange} />
            );
        case InputEnum.TextPrompt:
            return (
                <TextPromptWidget onTextChange={handleChange} onFocus={onFocus || errorOnFocusBlur}  />
            );
        default:
            return null;
    }
};
